import { toColor } from '../../../utils/ColorTransformator'
import { IRoom, RoomServiceType } from '../index'
import { IRoomData } from '../request/response'
import { dateWithoutOffsert } from '../../License/mappers/mapResponseToLicense'

export default function(item: IRoomData): IRoom {
  return {
    additionalBeds: item.additional_beds,
    additionalEquipment: item.additional_equipment,
    booking: item.booking_mapping === 1,
    bookingRoomId:
      item.booking_room_id && item.booking_room_id !== null
        ? String(item.booking_room_id)
        : undefined,
    city: item.city,
    coords_lat: item.coords_lat,
    coords_lng: item.coords_lng,
    airbnb_mapping: !!Number(item.airbnb_mapping),
    customColor: toColor(item.custom_color),
    description: item.description,
    doubleBed: item.doubleBed,
    iCalendar: item.icalendar_mapping ? item.icalendar_mapping !== 0 : false,
    iCalendarSync: item.icalendar_mapping ? Number(item.icalendar_mapping) : 0,
    id: item.id,
    id_country: Number(item.id_country),
    isDeleted: item.deleted === '1',
    modifiedAt: new Date(Number(item.modify_date) * 1000),
    ical_token: item.ical_token,
    name: item.name,
    position: Number(item.position),
    post_code: item.post_code,
    roomSize: item.capacity,
    serviceBedding:
      item.room_service_bedding && item.room_service_bedding !== '0'
        ? dateWithoutOffsert(new Date(Number(item.room_service_bedding) * 1000))
        : undefined,
    serviceCleaning:
      item.room_service_cleaning && item.room_service_cleaning !== '0'
        ? dateWithoutOffsert(
            new Date(Number(item.room_service_cleaning) * 1000),
          )
        : undefined,
    serviceCleaningStage: item.room_service_cleaning_stage
      ? (item.room_service_cleaning_stage as RoomServiceType)
      : RoomServiceType.Waiting,
    serviceTowels:
      item.room_service_towels && item.room_service_towels !== '0'
        ? dateWithoutOffsert(new Date(Number(item.room_service_towels) * 1000))
        : undefined,
    singleBed: item.singleBed,
    size: item.size,

    street: item.street,
    title: item.title,
    type: item.type,
    widget: String(item.show_in_search) ? Number(item.show_in_search) : 0,
  }
}
